import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

import { useBusinessAuth } from "../context/BusinessAuthContext";

/**
 * Pay is confidential (owner decision C5). A pay page opened without the permission for it says so plainly instead
 * of rendering an empty shell. This is guidance only: the server refuses the data either way.
 */
export default function PayAreaGuard({ anyOf, title, children }) {
  const auth = useBusinessAuth();
  const isOwner = String(auth?.role || auth?.user?.role || "").toUpperCase() === "OWNER";
  const allowed = isOwner || anyOf.some((permission) => auth?.hasPermission?.(permission));
  if (allowed) return children;

  return (
    <section role="alert" className="mx-auto max-w-xl rounded-2xl border border-neutral-200 bg-white p-6 text-center dark:border-neutral-800 dark:bg-neutral-900">
      <ShieldAlert className="mx-auto h-8 w-8 text-neutral-400" aria-hidden="true" />
      <h1 className="mt-3 text-lg font-semibold text-neutral-900 dark:text-neutral-50">{title} is not part of your role</h1>
      <p className="mt-2 text-sm text-neutral-600 dark:text-neutral-300">
        Employee pay is confidential, so this page is open only to people whose role includes it. If you need it for
        your work, ask the business owner or an administrator. Your own pay and payslips are in My HR.
      </p>
      <Link to="/business/hr/me" className="business-primary-action mt-4 inline-flex rounded-xl bg-neutral-900 px-4 py-2 text-sm font-semibold text-white dark:bg-neutral-100 dark:text-neutral-900">
        Go to My HR
      </Link>
    </section>
  );
}
